import { AxiosRequestConfig } from "axios";

import { axiosPrivate, isCanceled } from "../axios";

const useAxiosPrivate = () => {
  const getData = (resource: string, headers?: any) =>
    axiosPrivate.get(resource, headers);

  const postData = (
    resource: string,
    payload?: any,
    config?: AxiosRequestConfig
  ) => axiosPrivate.post(resource, payload, config);

  const putData = (resource: string, payload?: any) =>
    axiosPrivate.put(resource, payload);

  const patchData = (resource: string, payload?: any) =>
    axiosPrivate.patch(resource, payload);

  const deleteData = (resource: string, id?: number | string) => {
    const deleteString = id ? `${resource}/${id}` : resource;
    return axiosPrivate.delete(deleteString);
  };

  const bulkDeleteData = (resource: string, payload: any) =>
    axiosPrivate.post(`${resource}/BulkDelete`, payload);

  const bulkRemoveData = (resource: string, payload: any) =>
    axiosPrivate.post(`${resource}/Bulk/Remove`, payload);

  const bulkMoveData = (resource: string, payload: any) =>
    axiosPrivate.post(`${resource}/BulkMove`, payload);

  return {
    axiosPrivate,
    getData,
    postData,
    putData,
    deleteData,
    bulkDeleteData,
    bulkRemoveData,
    bulkMoveData,
    isCanceled,
    patchData
  };
};

export default useAxiosPrivate;
